import {Tile} from '@kit';

import React from 'react';

import {imageUrl, variantSrcSet} from '../../components/utils';
import {tipographText} from '../../components/utils/md';
import {useDayWikiArticlesQuery} from '../../generated/types';
import {moscowToday} from './day-card';

import css from './day-wiki.module.css';

export const DayWiki: React.FC = () => {
	const {data} = useDayWikiArticlesQuery({ssr: true, variables: {date: moscowToday()}});
	const articles = data?.dayWikiArticles || [];
	if (!articles.length) return null;

	return (
		<ul className={css.grid}>
			{articles.map((article) => (
				<li key={article.id}>
					<Tile
						route="wikiArticle"
						params={{id: article.id}}
						appearance="poster"
						className={css.tile}
						media={
							<span className={css.preview}>
								{article.imagePath && (
									<img
										className={css.previewImage}
										src={imageUrl(article.imagePath, 900)}
										srcSet={variantSrcSet(article.imagePath)}
										sizes="(max-width: 600px) 90vw, 320px"
										alt=""
										loading="lazy"
									/>
								)}
							</span>
						}
						title={tipographText(article.title)}
						description={article.text && tipographText(article.text)}
					/>
				</li>
			))}
		</ul>
	);
};
